/* eslint-disable no-case-declarations */

import {
  CHANGE_FILTERS,
  EDIT_AUDIENCES_FAIL,
  EDIT_AUDIENCES_OK,
  EDIT_AUDIENCES_REQUEST,
  LOAD_SUBSCRIPTIONS_FAIL,
  LOAD_SUBSCRIPTIONS_FILTERS_FAIL,
  LOAD_SUBSCRIPTIONS_FILTERS_OK,
  LOAD_SUBSCRIPTIONS_COUNT_FAIL,
  LOAD_SUBSCRIPTIONS_COUNT_OK,
  LOAD_SUBSCRIPTIONS_COUNT_REQUESTED,
  LOAD_SUBSCRIPTIONS_FILTERS_REQUESTED,
  LOAD_SUBSCRIPTIONS_OK,
  LOAD_SUBSCRIPTIONS_REQUESTED,
} from "../actions/subscriptions";

const INITIAL_STATE = {
  loadingFilters: false,
  filtersLoaded: false,
  errors: null,
  filters: {},
  loading: false,
  subscriptions: {},
  subscriptionsLoaded: false,
  loadingSubscriptionsCount: false,
  subscriptionsCount: {},
  preparedFilters: [],
  editAudiencesSuccess: null,
  editAudiencesLoading: false,
  editAudiencesErrors: "",
};

export function subscriptionsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case LOAD_SUBSCRIPTIONS_FILTERS_REQUESTED:
      return {
        ...state,
        loadingFilters: true,
      };

    case LOAD_SUBSCRIPTIONS_FILTERS_OK:
      return {
        ...state,
        loadingFilters: false,
        filtersLoaded: true,
        filters: action.data,
      };

    case LOAD_SUBSCRIPTIONS_FILTERS_FAIL:
      return {
        ...INITIAL_STATE,
        loadingFilters: false,
        errors: action.errors,
      };

    case LOAD_SUBSCRIPTIONS_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case LOAD_SUBSCRIPTIONS_OK:
      return {
        ...state,
        loading: false,
        subscriptions: action.data,
        filters: state.filters,
        preparedFilters: state.preparedFilters,
        subscriptionsLoaded: true,
      };

    case LOAD_SUBSCRIPTIONS_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors,
      };

    case LOAD_SUBSCRIPTIONS_COUNT_REQUESTED:
      return {
        ...state,
        loadingSubscriptionsCount: true,
      };

    case LOAD_SUBSCRIPTIONS_COUNT_OK:
      return {
        ...state,
        loadingSubscriptionsCount: false,
        subscriptionsCount: action.data,
      };

    case LOAD_SUBSCRIPTIONS_COUNT_FAIL:
      return {
        ...state,
        loadingSubscriptionsCount: false,
        errors: action.errors,
      };

    case CHANGE_FILTERS:
      return {
        ...state,
        preparedFilters: action.preparedFilters,
      };

    case EDIT_AUDIENCES_REQUEST:
      return {
        ...state,
        editAudiencesSuccess: false,
        editAudiencesLoading: true,
        editAudiencesErrors: "",
      };

    case EDIT_AUDIENCES_OK:
      return {
        ...state,
        editAudiencesSuccess: true,
        editAudiencesLoading: false,
        editAudiencesErrors: "",
      };

    case EDIT_AUDIENCES_FAIL:
      return {
        ...state,
        editAudiencesSuccess: false,
        editAudiencesLoading: false,
        editAudiencesErrors: action.errors,
      };

    default:
      return state;
  }
}
